export default {
  "hash": "9db02cd",
  "raw": "v3.7.0",
  "semverString": "3.7.0"
};